import { IAppState } from '../../../../../AppModulesWrapper';

export function selectIsServicesEnabled(state: IAppState): boolean {
  return state.servicePickerWidgetV2.promotion.toggle.checked;
}
